import { useMutation, useQuery } from '@tanstack/react-query';
import {
  deleteMyCreation,
  enterContest,
  EnterContestRequest,
  getMyCreations,
  GetMyCreationsParams,
  GetMyCreationsResponse,
  MyCreation,
  saveMyCreation,
  SaveMyCreationRequest,
  SaveMyCreationResponse,
  updateMyCreation,
  UpdateMyCreationRequest,
} from '../../services/myCreationsApi';

export const useSaveMyCreation = () => {
  return useMutation<SaveMyCreationResponse, Error, SaveMyCreationRequest>({
    mutationFn: (data: SaveMyCreationRequest) => saveMyCreation(data),
  });
};

export const useGetMyCreations = (params?: GetMyCreationsParams) => {
  return useQuery<GetMyCreationsResponse, Error>({
    queryKey: ['myCreations', params],
    queryFn: () => getMyCreations(params),
  });
};

export const useDeleteMyCreation = () => {
  return useMutation<void, Error, string>({
    mutationFn: (id: string) => deleteMyCreation(id),
  });
};

export const useEnterContest = () => {
  return useMutation<
    MyCreation,
    Error,
    { id: string; data: EnterContestRequest }
  >({
    mutationFn: ({ id, data }) => enterContest(id, data),
  });
};

export const useUpdateMyCreation = () => {
  return useMutation<
    SaveMyCreationResponse,
    Error,
    { id: string; data: UpdateMyCreationRequest }
  >({
    mutationFn: ({ id, data }) => updateMyCreation(id, data),
  });
};
